"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAVEL_CONCEPT_KEY = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var moment_1 = tslib_1.__importDefault(require("moment"));

var __1 = require("../../..");

var FoldButton_1 = tslib_1.__importDefault(require("../../../Buttons/FoldButton"));

var styles = tslib_1.__importStar(require("./index.style"));

var helper_1 = require("../../../../styles/helper");

var useOverflow_1 = tslib_1.__importDefault(require("../../../../hooks/useOverflow"));

var TRAVEL_CONCEPT;

(function (TRAVEL_CONCEPT) {
  TRAVEL_CONCEPT["OFFICIAL"] = "\uCD9C\uC7A5, \uD559\uD68C";
  TRAVEL_CONCEPT["FRIENDS"] = "\uCE5C\uAD6C\uB4E4\uACFC \uB5A0\uB098\uB294 \uC5EC\uD589";
  TRAVEL_CONCEPT["ALONE"] = "\uD63C\uC790 \uB5A0\uB098\uB294 \uC5EC\uD589";
  TRAVEL_CONCEPT["HONEYMOON"] = "\uD5C8\uB2C8\uBB38";
  TRAVEL_CONCEPT["CHILDREN"] = "\uC790\uB140\uC640 \uD568\uAED8 \uB5A0\uB098\uB294 \uC5EC\uD589";
  TRAVEL_CONCEPT["PARTNER"] = "\uBC30\uC6B0\uC790\uC640 \uB2E8 \uB458\uC774 \uB5A0\uB098\uB294 \uC5EC\uD589";
  TRAVEL_CONCEPT["PARENTS"] = "\uBD80\uBAA8\uB2D8\uACFC \uD568\uAED8 \uB5A0\uB098\uB294 \uC5EC\uD589";
  TRAVEL_CONCEPT["LOVER"] = "\uC5F0\uC778\uACFC \uD568\uAED8 \uB5A0\uB098\uB294 \uB85C\uB9E8\uD2F1\uD55C \uC5EC\uD589";
  TRAVEL_CONCEPT["ETC"] = "\uAE30\uD0C0";
})(TRAVEL_CONCEPT || (TRAVEL_CONCEPT = {}));

var TRAVEL_CONCEPT_KEY;

(function (TRAVEL_CONCEPT_KEY) {
  TRAVEL_CONCEPT_KEY["OFFICIAL"] = "OFFICIAL";
  TRAVEL_CONCEPT_KEY["FRIENDS"] = "FRIENDS";
  TRAVEL_CONCEPT_KEY["ALONE"] = "ALONE";
  TRAVEL_CONCEPT_KEY["HONEYMOON"] = "HONEYMOON";
  TRAVEL_CONCEPT_KEY["CHILDREN"] = "CHILDREN";
  TRAVEL_CONCEPT_KEY["PARTNER"] = "PARTNER";
  TRAVEL_CONCEPT_KEY["LOVER"] = "LOVER";
  TRAVEL_CONCEPT_KEY["PARENTS"] = "PARENTS";
  TRAVEL_CONCEPT_KEY["ETC"] = "ETC";
})(TRAVEL_CONCEPT_KEY = exports.TRAVEL_CONCEPT_KEY || (exports.TRAVEL_CONCEPT_KEY = {}));

function ReviewListItem(_ref) {
  var review = _ref.review,
      className = _ref.className,
      onClickImage = _ref.onClickImage;
  var score = review.score,
      username = review.username,
      travelConcept = review.travelConcept,
      createdAt = review.createdAt,
      comment = review.comment,
      imageUrls = review.imageUrls,
      optionTitle = review.optionTitle;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFold = _react_1$useState2[0],
      setFold = _react_1$useState2[1];

  var commentDivEl = react_1.useRef(null);
  var handleNotFold = react_1.useCallback(function () {
    setFold(false);
  }, []);
  useOverflow_1.default(commentDivEl, 125, function () {
    setFold(true);
  });
  var ageGroup = travelConcept.ageGroup,
      purpose = travelConcept.purpose;
  var isLongOptionTitle = optionTitle.length > 30;
  return jsx_runtime_1.jsx(react_1.Fragment, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: [styles.wrapper, imageUrls.length === 0 && styles.fullWidth],
      className: className
    }, {
      children: [jsx_runtime_1.jsxs("div", {
        children: [jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.basic
        }, {
          children: [jsx_runtime_1.jsx(__1.RatingStars, {
            ratingValue: score
          }, void 0), jsx_runtime_1.jsx("span", Object.assign({
            className: "username"
          }, {
            children: username
          }), void 0)]
        }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.description
        }, {
          children: [jsx_runtime_1.jsxs("div", Object.assign({
            css: styles.descriptionInfo(isLongOptionTitle)
          }, {
            children: [ageGroup && "".concat(ageGroup, "\uB300 \xB7 "), purpose && "".concat(TRAVEL_CONCEPT[purpose], " \xB7 "), moment_1.default(createdAt).format('YYYY. MM. DD'), jsx_runtime_1.jsx("span", {
              css: styles.divider
            }, void 0), !isLongOptionTitle && jsx_runtime_1.jsx("span", {
              children: "".concat(optionTitle, " \uC774\uC6A9")
            }, void 0)]
          }), void 0), isLongOptionTitle && jsx_runtime_1.jsx("div", {
            children: "".concat(optionTitle, " \uC774\uC6A9")
          }, void 0)]
        }), void 0), jsx_runtime_1.jsx("div", Object.assign({
          ref: commentDivEl,
          css: [styles.text(isFold), isFold && helper_1.multilineEllipses(5)]
        }, {
          children: comment
        }), void 0), isFold && jsx_runtime_1.jsx(FoldButton_1.default, {
          onClick: handleNotFold,
          isFold: isFold
        }, void 0)]
      }, void 0), imageUrls.length > 0 && jsx_runtime_1.jsx("div", Object.assign({
        css: styles.imageWrapper
      }, {
        children: imageUrls.map(function (imageUrl) {
          return jsx_runtime_1.jsx("img", {
            css: [styles.image, onClickImage && styles.clickableImage],
            src: "".concat(imageUrl, "?height=").concat(Math.ceil(125 * window.devicePixelRatio)),
            alt: "review item",
            onClick: function onClick() {
              return onClickImage && onClickImage(imageUrl);
            }
          }, imageUrl);
        })
      }), void 0)]
    }), void 0)
  }, void 0);
}

exports.default = react_1.memo(ReviewListItem);